import "./widget.scss";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import {db} from "../../firebase"

const SmallRoom = ({ type }) => {
  let data;

  //temporary
  const amount = 70;
  

  switch (type) {
    case "smallroom":
      data = {
        title: "Small Room Booking",
        isMoney: true,
        // link: "View customers",
        icon: (
          <MonetizationOnOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(128, 0, 128, 0.2)",
              color: "red",
            }}
          />
        ),
      };
      break;
    default:
      break;
  }

  useEffect(() => {
    const fectchData = async() =>{
      const today = new Date() 
    }
    fectchData()
    
  }, [])
   

  return (
    <div className="widget">
      <div className="left">
        <span className="title">{data.title}</span>
        <span className="counter">
          {data.isMoney && "$"} {amount}
        </span>
        <span className="link">{data.link}</span>
      </div>
      <div className="right">
        {/* <div className="percentage positive">
          <KeyboardArrowUpIcon />
          {diff} %
        </div> */}
        {data.icon}
      </div>
    </div>
  );
};

export default SmallRoom;
